module.exports = __webpack_public_path__ + "img/bluesparkle.fa83b320.svg";